import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isObjectNullOrEmpty } from '../../../../../utils/helpers';

const StyledBadge = styled.i`
  ${p => isObjectNullOrEmpty(p.style) ? 'color: #64747c;' : p.style};
  font-size: 12px;
  margin-left: 3px;
`;

const BlockBadge = ({ icon, iconStyle = {} }) =>
  <StyledBadge className={icon.includes('fa-') ? icon : `fas fa-${icon}`} style={iconStyle} />;

BlockBadge.propTypes = {
  icon: PropTypes.string,
  iconStyle: PropTypes.object,
};

export default BlockBadge;
